export enum Experiments {
  NavigateToMemberProfile = 'specs.chat.NavigateToMemberProfile',
  ChangePageTitle = 'specs.chat.ChangePageTitleChatWidget',
  StartPrivateChatFromOutside = 'specs.chat.StartPrivateChatFromOutside',
}
